import { getCallMetrics } from '@/services/dashboard-service/dashboard.service';
import { DashboardFilters } from '@/services/dashboard-service/dashboard.service.types';
import { ReactQueryKeys } from '@/utils/react-query-keys';
import { useQuery } from '@tanstack/react-query';

export const useCallMetric = (params: DashboardFilters, isCompanyAdmin?: boolean) => {
  const {
    data: callMetricData,
    error,
    isPending,
    refetch,
  } = useQuery({
    queryKey: ReactQueryKeys.CALL_METRICS(params),
    queryFn: () => getCallMetrics(params),
    enabled: isCompanyAdmin || !!params.company_name,
  });

  return { callMetricData, error, isPending, refetch };
};
